import * as React from 'react';
import { useEffect,useState } from 'react';
import FaceService from '../services/face.service';
import TagSearchService from '../services/tagSearch.service';
import TagModelComponent from '../components/TagModel.Component';
import {IFaceMatch } from '../@types/FaceMatch';
import {ITag } from '../@types/Tag';
import {IsFaceMatch} from '../helpers/checkIsType';
import { handleHttpError } from '../helpers/HttpErrorHandler';

const TagSearch:React.FC = () => {

    const loadMoreSteps = 50;
    const firstLoadNum = loadMoreSteps;
    const loadMoreMax = firstLoadNum + (loadMoreSteps * 2);

    const [showLatest, setShowLatest] = useState<boolean>(true);
    const [isMore, setIsMore] = useState<boolean>(false);
    const [loadMoreNum, setloadMoreNum] = useState<number>(firstLoadNum);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [faces,popFaceData] = React.useState<IFaceMatch[]>([]);
    const [searchString, setSearchString] = useState("");//latina big tits blue eyes
    const [tags,popTags] = React.useState<[string, ITag][]>([]);


    const faceService = FaceService.getInstance();
    const tagSearchService = TagSearchService.getInstance();

    useEffect(()=>{ 
      document.title = 'Camgirl finder using our willingness and tag search engine';
      let descMeta=document.querySelector("meta[name='description']");
      if(descMeta!==null)descMeta.setAttribute("content", 'Camgirl model finder using our model keyword and tag search engine. Search and find camgirls using their characteristics and perfomer willingness tags');
      let canNAme=document.querySelector("link[rel='canonical']");
      if(canNAme!==null)canNAme.setAttribute("href", 'https://www.camgirlcrawler.net/camgirl-search');

        getLatestFaces();
        getTags();
       }, []); // empty array means only once

const handleSubmit = (event:any) => {
        event.preventDefault();
        reset();
        tagSearch(0,firstLoadNum);
      }

const loadMore = (event:any) => {
        event.preventDefault();
        tagSearchLoadMore(loadMoreNum , loadMoreSteps);
      }

const addTagToSearch = (event:any) => {

        let newsearchString = '';

        if(searchString.indexOf(event.target.innerText) !== -1)
        {
          event.target.style = 'background-color:white;color:#626163'
          newsearchString = searchString.replace(event.target.innerText,'');  
        }else{
          event.target.style = 'background-color:#0d6efd;color:white'
          if(searchString==='') 
            newsearchString = event.target.innerText;
          else
            newsearchString = searchString + ' ' + event.target.innerText   
        }

        setSearchString(newsearchString.trim().replace(/\s+/g, " "));
      }
const clearTagSearch = () => {
        reset();
        setSearchString('');
        const elements = Array.from(document.getElementsByClassName("tag"));
        elements.map(element=>{
            element.setAttribute('style', 'background-color: #ffffff');
        })
      }

const getTags = () =>
      {
        tagSearchService.getTags().then(response => { 
                if(response.length >0){
                  let grouped = response.reduce(
                  (result:any, currentValue:any) => { 
                    (result[currentValue['tagCategory']] = result[currentValue['tagCategory']] || []).push(currentValue);
                    return result;
                  }, {});
                  popTags(grouped);
                  }else{
                    popTags([]);
                    setErrorMsg(handleHttpError(response));
                } 
              }).catch(error => {
                setErrorMsg(handleHttpError(500));
                //console.log(error)
                console.clear();
        });
      }
       
const tagSearch = (skip: number, take: number) => {

        setErrorMsg("");
        setloadMoreNum(firstLoadNum);
        setIsMore(false);
        setLoading(true);

        if(searchString === '')
        {
            reset();
           //getLatestFaces();
            return;
        }

        tagSearchService.getTagSearchResults(searchString,skip,take,false).then(response => { 
          if(response.length >0 && IsFaceMatch(response[0])){
              if(response[response.length-1].name === "==")
              {
                setIsMore(true);
                response.pop();
              }else
                setIsMore(false);
              popFaceData(response);
           }else{
              setErrorMsg(handleHttpError(response));
           } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
          //console.log(error)
          console.clear();
        }).then(() =>{
              setLoading(false);
        });
  }

const tagSearchLoadMore = (skip: number, take: number) => {

        if(loadMoreNum >= loadMoreMax) return;

        setLoading(true);

        tagSearchService.getTagSearchResults(searchString,skip,take,false).then(response => {         
          if(response.length>0 && IsFaceMatch(response[0])){
            if(response[response.length-1].name === "==")
              {
                setIsMore(true);
                response.pop();
              }else
                setIsMore(false);

            var existingFaceData = faces;
            var newArray = existingFaceData.concat(response);
            popFaceData(newArray);
            if(response.length >= loadMoreSteps)
                  setloadMoreNum(loadMoreNum + loadMoreSteps);
            else
                setloadMoreNum(loadMoreMax);
          }else{
            setIsMore(false);
          } 
        }).catch(error => {
          setErrorMsg(handleHttpError(500));
          //console.log(error)
          console.clear();
        }).then(() =>{
              setLoading(false);
        });
  }


const getLatestFaces = () =>
            {
                setShowLatest(true);
                      faceService.getLatestFaces().then(response => { 
                        if(response.length >0 && IsFaceMatch(response[0])){
                          popFaceData(response.slice(0, 15));
                          }else{
                            popFaceData([]);
                          } 
                        }).catch(error => {
                            popFaceData([]);
                        }).then(() =>{
                            setLoading(false);
                });
    }

const reset = () => {
        setLoading(false);
        setShowLatest(false);
        popFaceData([]);
        setIsMore(false);
        setErrorMsg('');
    }

return (
        <div>
            <section>
            <div className='pageHeader'>
              <h1>Camgirl keyword & tag search</h1>
              <div><b><i>Search and find camgirl models by your favourite categories!</i></b></div>
            </div>
            <div className='info' id='info'>
                Welcome to our camgirl keyword & tag search engine. 
                To find camgirl models by your favourite categories simply enter them as keywords and press the 'Start Search' button. 
                For best results use specfic category keywords according to model attirbutes. Such as model ethnicity, body attributes and apperance attributes.
                For example, a valid search string could be 'latina big tits long hair'. This will return camgirl models most closely matching those keywords.
				        The more category keywords or tags you use in a search the more our camgirl model database is filtered. 
				        If only a small number of camgirl models are returned for a search. Try to use less keywords to reduce the
                number of camgirl models that are filtered out of the search results.
                Search results are always returned by the 'last seen' models first. 
          </div>
      </section>
          <div className='resultsThumbsOutter' style={{marginTop:'30px'}} >
                  {Object.values(tags).map((innerArray:[string,ITag], index) => (
                    <>
                      <div className='cat_tag'>{Object.keys(tags)[index]}:</div>
                      {innerArray.map((elm : string | ITag, innerIndex) => (
                        <div className='tag' onClick={(e) => addTagToSearch(e)} >{(elm as ITag).tag}</div>
                      ))}
                    </>
                  ))}
          </div>
          <form onSubmit={handleSubmit} className="searchBox" style={{textAlign:'center'}} >
            <div>
              <input hidden={true} className="form-control" onChange={(e) => setSearchString(e.target.value)}/>
            </div>
            <div>
              <div style={{display:'inline-block'}}>
                  <button id="nameSearchBtn" className="btn" style={{background:'#198754',color:'white'}} onClick={handleSubmit}>
                  Start Search&nbsp;🔎︎
                  </button>
                 </div>
                  <div className='clearTagSearch' hidden={searchString===''} onClick={clearTagSearch} style={{display:'inline-block'}} title='Clear tag selection'>X</div>
            </div>
            </form>
          <div style={{minHeight:'750px',marginTop:'60px'}}>
                <h2 style={{paddingTop:'20px'}} hidden={!showLatest || faces.length===0}>Latest camgirls added for tag searches:</h2>
                <div className='resultsThumbsOutter'>
                  {faces.length>0 && faces.map((face: IFaceMatch) => (
                    <TagModelComponent key={face.name}  face={face} imgWidth='250' imgHeight='250'/>
                    ))} 
                </div>         
            {loading && faces.length===0 &&(      
              <div style={{padding:'30px'}}>                 
                  <img src={'images/spinner.gif'} alt="Loading" height={'25px'} width={'25px'}/>
              </div>  
            )}     
            {errorMsg && (
              <div className="alert alert-danger errorMessage" role="alert" style={{marginTop:'30px'}}>
                {errorMsg}
              </div>
              )}
            {!errorMsg && isMore && loadMoreNum < loadMoreMax && (
            <div style={{margin:'30px'}}>
            <button
                  className="btn btn-success"
                  onClick={loadMore}>
                   Show More
                </button>
            </div> 
            )} 
            <div>{loading && faces.length > 0 && loadMoreNum < loadMoreMax && (                       
                  <img src={'images/spinner.gif'} alt="Loading"  width={'25px'}/>
                  )}
            </div>
          </div>                 
        </div>
  );
}
export default TagSearch;